import {shouldDisableLclPackageOption} from "utils/lclPackageRestrictions";

export type PackageContainerValue = {
  id?: number | string | null;
  name?: string | null;
} | null;

type Params = {
  packageContainer: PackageContainerValue;
  typeLoad?: string | null;
  destinationId?: number | null;
  itemIndex: number;
};

export default function validatePackageContainerIsAllowed({
  packageContainer,
  typeLoad,
  destinationId,
  itemIndex,
}: Params) {
  const packageId = (() => {
    const raw = packageContainer?.id;
    if (raw === null || raw === undefined) return raw;
    if (typeof raw === "number") return raw;
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
  })();

  if (packageId === null || packageId === undefined) return true;

  return shouldDisableLclPackageOption({
    typeLoad,
    destinationId,
    packageId,
  })
    ? `Item de carga ${itemIndex + 1} - Pacote não permitido para este processo.`
    : true;
}
